// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","menuTooltip":"ComponentMenu_menuTooltip__15kTu","searchInput":"ComponentMenu_searchInput__2CySv"};